import { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { adminlimit } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isEmpty,
  showLoader,
  hideLoader,
  showAlert,
  isSingleSelect,
  showDate,
  onlyNumberDot,
  jsUcfirstFun,
  validateDate,
  apiDate,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidatetravel";
const modulePath = "/candidate";
const moduleName = "Travel";
const moduleID = 23;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      portAgentList: [],
      editID: "",
      postdata: {
        travel_date: "",
        travel_from: "",
        travel_to: "",
        travel_mode: "",
        travel_status: "",
        ticket_number: "",
        agent_name: "",
        portAgent: "",
        travel_amount: "",
        reason: "",
      },
      detaildata: [],
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_travel_frm");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }

    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("portagent/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ portAgentList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $("#addNewTravel").trigger("click");
            const result = res.data.result;
            this.setState({
              postdata: {
                travel_date: validateDate(result.travel_date),
                travel_from: result.travel_from || "",
                travel_to: result.travel_to || "",
                travel_mode: result.travel_mode !== "" && result.travel_mode !== null ? { label: jsUcfirstFun(result.travel_mode), value: result.travel_mode } : "",
                travel_status: result.travel_status !== "" && result.travel_status !== null ? { label: jsUcfirstFun(result.travel_status), value: result.travel_status } : "",
                ticket_number: result.ticket_number || "",
                agent_name: result.agent_name || "",
                portAgent: result.portAgent !== "" && result.portAgent !== null ? { label: result.portAgent, value: result.portAgent } : "",
                travel_amount: result.travel_amount || "",
                reason: result.reason || "",
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  fieldChange = (field, value) => {
    if (field === "travel_amount") {
      value = onlyNumberDot(value);
    }
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_travel_frm");
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      travel_date: apiDate(postData.travel_date),
      travel_from: postData.travel_from.toUpperCase(),
      travel_to: postData.travel_to.toUpperCase(),
      travel_mode: postData.travel_mode?.value ?? "",
      travel_status: postData.travel_status?.value ?? "",
      ticket_number: postData.ticket_number.toUpperCase(),
      agent_name: postData.agent_name.toUpperCase(),
      portAgent: postData.portAgent?.value,
      travel_amount: postData.travel_amount.toUpperCase(),
      reason: postData.reason.toUpperCase(),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, postObject)
      .then((res) => {
        hideLoader("submit_travel_frm");
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          this.resetFrom();
        }
      })
      .catch((err) => {
        hideLoader("submit_travel_frm");
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  closePopup() {
    this.resetFrom();
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        travel_date: "",
        travel_from: "",
        travel_to: "",
        travel_mode: "",
        travel_status: "",
        ticket_number: "",
        agent_name: "",
        portAgent: "",
        travel_amount: "",
        reason: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">Travel Details</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#travelmodal"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="addNewTravel"
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Travel Date</th>
                            <th>Travel From</th>
                            <th>Travel To</th>
                            <th>Travel Amount</th>
                            <th>Travel Mode</th>
                            <th>Travel Status</th>
                            <th>Ticket Number</th>
                            <th>Agent Name</th>
                            <th>Port Agent</th>
                            <th>Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                    <td className="text-center text-nowrap" valign="top">
                                      {hasPermission(moduleID, "edit") && (
                                        <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                          <i className="fa fa-pencil-square-o"></i>
                                        </a>
                                      )}
                                      {hasPermission(moduleID, "delete") && (
                                        <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      )}
                                    </td>
                                  )}
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{showDate(item.travel_date)}</td>
                                  <td>{item.travel_from}</td>
                                  <td>{item.travel_to}</td>
                                  <td>{item.travel_amount}</td>
                                  <td>{item.travel_mode?.toUpperCase()}</td>
                                  <td>{item.travel_status?.toUpperCase()}</td>
                                  <td>{item.ticket_number}</td>
                                  <td>{item.agent_name}</td>
                                  <td>{item.portAgent}</td>
                                  <td>{item.reason}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={12}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="travelmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{`${this.state.editID !== "" ? "Update" : "Add New"} Travel`}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <PostForm
                {...this.props}
                fields={this.state.postdata}
                portAgentList={this.state.portAgentList}
                restForm={this.state.restForm}
                sateValChange={this.sateValChange}
                onChange={this.fieldChange}
                onValid={this.handleSubmit}
                closePopup={this.closePopup.bind(this)}
                editID={this.state.editID}
                error_msg={this.state.error_msg}
                onInvalid={() => {
                  console.log("Form invalid!");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

function validationConfig(props) {
  const { travel_date, travel_from, travel_to, travel_mode, travel_status, ticket_number, agent_name, portAgent, travel_amount } = props.fields;

  return {
    fields: ["travel_date", "travel_from", "travel_to", "travel_mode", "travel_status", "ticket_number", "agent_name", "portAgent", "travel_amount"],
    validations: {
      travel_date: [[isEmpty, travel_date]],
      travel_from: [[isEmpty, travel_from]],
      travel_to: [[isEmpty, travel_to]],
      travel_mode: [[isSingleSelect, travel_mode]],
      travel_status: [[isSingleSelect, travel_status]],
      ticket_number: [[isEmpty, ticket_number]],
      agent_name: [[isEmpty, agent_name]],
      portAgent: [[isSingleSelect, portAgent]],
      travel_amount: [[isEmpty, travel_amount]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgtravel_date,
      errMsgtravel_from,
      errMsgtravel_to,
      errMsgtravel_mode,
      errMsgtravel_status,
      errMsgticket_number,
      errMsgagent_name,
      errMsgportAgent,
      errMsgtravel_amount = "";
    if ($validation.travel_date.error.reason !== undefined) {
      errMsgtravel_date = $validation.travel_date.show && <span className="error">{$validation.travel_date.error.reason}</span>;
    }
    if ($validation.travel_from.error.reason !== undefined) {
      errMsgtravel_from = $validation.travel_from.show && <span className="error">{$validation.travel_from.error.reason}</span>;
    }
    if ($validation.travel_to.error.reason !== undefined) {
      errMsgtravel_to = $validation.travel_to.show && <span className="error">{$validation.travel_to.error.reason}</span>;
    }
    if ($validation.travel_mode.error.reason !== undefined) {
      errMsgtravel_mode = $validation.travel_mode.show && <span className="error">{$validation.travel_mode.error.reason}</span>;
    }
    if ($validation.travel_status.error.reason !== undefined) {
      errMsgtravel_status = $validation.travel_status.show && <span className="error">{$validation.travel_status.error.reason}</span>;
    }
    if ($validation.ticket_number.error.reason !== undefined) {
      errMsgticket_number = $validation.ticket_number.show && <span className="error">{$validation.ticket_number.error.reason}</span>;
    }
    if ($validation.agent_name.error.reason !== undefined) {
      errMsgagent_name = $validation.agent_name.show && <span className="error">{$validation.agent_name.error.reason}</span>;
    }
    if ($validation.portAgent.error.reason !== undefined) {
      errMsgportAgent = $validation.portAgent.show && <span className="error">{$validation.portAgent.error.reason}</span>;
    }
    if ($validation.travel_amount.error.reason !== undefined) {
      errMsgtravel_amount = $validation.travel_amount.show && <span className="error">{$validation.travel_amount.error.reason}</span>;
    }

    return (
      <>
        <div>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Travel Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Issue Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.travel_date}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "travel_date")}
                  />
                  {errMsgtravel_date}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Travel From<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Account Number"
                    name="travel_from"
                    value={fields.travel_from}
                    {...$field("travel_from", (e) => onChange("travel_from", e.target.value))}
                  />
                  {errMsgtravel_from}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Travel To</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Travel To"
                    name="travel_to"
                    value={fields.travel_to}
                    {...$field("travel_to", (e) => onChange("travel_to", e.target.value))}
                  />
                  {errMsgtravel_to}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Travel Mode<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.travel_mode}
                    onChange={this.handleSelectChange.bind(this, "travel_mode")}
                    placeholder="Select Port Agent"
                    options={[
                      {
                        label: "Bus",
                        value: "bus",
                      },
                      {
                        label: "Train",
                        value: "train",
                      },
                      {
                        label: "Air",
                        value: "air",
                      },
                      {
                        label: "Cab",
                        value: "cab",
                      },
                    ]}
                  />
                  {errMsgtravel_mode}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Travel Status<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.travel_status}
                    onChange={this.handleSelectChange.bind(this, "travel_status")}
                    placeholder="Select Travel Status"
                    options={[
                      {
                        label: "Booked",
                        value: "booked",
                      },
                      {
                        label: "Cancelled",
                        value: "cancelled",
                      },
                      {
                        label: "Travelling",
                        value: "travelling",
                      },
                      {
                        label: "Travelled",
                        value: "travelled",
                      },
                    ]}
                  />
                  {errMsgtravel_status}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Ticket Number<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Ticket Number"
                    name="ticket_number"
                    value={fields.ticket_number}
                    {...$field("ticket_number", (e) => onChange("ticket_number", e.target.value))}
                  />
                  {errMsgticket_number}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Port Agent Name<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Agent Name"
                    name="agent_name"
                    value={fields.agent_name}
                    {...$field("agent_name", (e) => onChange("agent_name", e.target.value))}
                  />
                  {errMsgagent_name}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Port Agent<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.portAgent} onChange={this.handleSelectChange.bind(this, "portAgent")} placeholder="Select Port Agent" options={this.props.portAgentList} />
                  {errMsgportAgent}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Travel Amount<span className="lbl-error">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Travel Amount"
                    name="travel_amount"
                    value={fields.travel_amount}
                    {...$field("travel_amount", (e) => onChange("travel_amount", e.target.value))}
                  />
                  {errMsgtravel_amount}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Reason</label>
                  <input type="text" className="form-control upper-case" placeholder="Reason" name="reason" value={fields.reason} {...$field("reason", (e) => onChange("reason", e.target.value))} />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id="submit_travel_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
